import { Post } from "../services/api_helpers";

export const CalculateAlimony = (data) => {
    return Post("calculate/", data);
};

export const RegisterUser = (data) => {
    return Post("register/", data);
};

export const LoginUser = (data) => {
    return Post("login/", data);
};

export const SendAppealRequest = (data) => {
    return Post("request/", data);
};

export const SendActRequest = (data) => {
    return Post("act-request/", data);
};